import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Container } from '@mui/material';
import { faPlus, faDownload, faEllipsisVertical, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Menu, Text } from '@mantine/core';
import ConfirmationModal from '../common/ConfirmationModal';
import AddLicenseModal from './AddLicense';
import Table from '../common/CommonTable'
//import { getLicenseType } from '../../apis/axios';

const CompanyTable = ({ data = [], setCompanies, onEdit, setTableInstance }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [isAddOpen, setAddOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    expiry_date: '',
    no_license: '',
  });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const navigate = useNavigate();

  const handleConfirmDelete = () => {
    if (companyToDelete) {
      setCompanies((prev) => prev.filter((company) => company.id !== companyToDelete.id));
    }
    setIsModalOpen(false);
    setCompanyToDelete(null);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleRippleEffect = (e) => {
    const button = e.currentTarget;
    const ripple = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
    ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
    ripple.classList.add('export-button-ripple');

    button.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  const handleAddLicense = () => {
    if (isEditing && selectedCompany) {
      // Update the existing company's license expiry date
      setCompanies((prev) =>
        prev.map((company) =>
          company.id === selectedCompany.id
            ? { ...company, expiry_date: formData.expiry_date }
            : company
        )
      );
    } else {
      //console.log(`Adding License - Type: ${licenseType}, Expiry: ${formData.expiry_date}, Licenses: ${formData.no_license}`);
      // Add logic to save the new license data to the company here
    }
    closeModal();
  };


const handleManageLicense = (companyId) => {
    navigate('/license', { state: { companyId:companyId } });
  };

  const setOpen = () => {
    setIsEditing(false);
    setAddOpen(true);
    setSelectedCompany(null);
  };

  const closeModal = () => {
    setAddOpen(false);
    setIsEditing(false);
    setFormData({
      expiry_date: '',
      no_license: '',
    });
    setSelectedCompany(null);
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Company',
      size: 120,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: {
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 600,
          color: '#595C60',
        },
      },
    },
    {
      accessorKey: 'manager_email',
      header: 'Manager Email',
      size: 120,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: {
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 600,
          color: '#595C60',
        },
      },
    },
    {
      accessorKey: 'device_count',
      header: 'Devices',
      size: 100,
      minSize: 100,
      mantineTableBodyCellProps: {
        style: {
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 600,
          color: '#595C60',
        },
      },
    },
   
    {
      accessorKey: 'actions',
      header: 'Actions',
      size: 120,
      minSize: 100,
      Cell: ({ row, table }) => {
        const handleDeleteClick = () => {
          setCompanyToDelete(row.original);
          setIsModalOpen(true);
        };

        const handleEdit = () => {
          const onEdit = table.options.meta?.onEdit;
          if (onEdit && typeof onEdit === 'function') {
            onEdit(row.original);
          }
        };

        return (
          <div className="flex justify-start items-center space-x-6" style={{ backgroundColor: 'transparent' }}>
            <FontAwesomeIcon
              icon={faEdit}
              size="lg"
              className="text-[#FF9F43] cursor-pointer hover:text-[#e68f3b]"
              title="Edit"
              onClick={handleEdit}
            />
            <FontAwesomeIcon
              icon={faTrash}
              size="lg"
              className="text-[#E74C3C] cursor-pointer hover:text-[#c0392b]"
              title="Delete"
              onClick={handleDeleteClick}
            />
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <FontAwesomeIcon
                  icon={faEllipsisVertical}
                  size="lg"
                  style={{ color: '#595C60' }}
                  className="cursor-pointer"
                  title="More Actions"
                />
              </Menu.Target>
              <Menu.Dropdown>
                
                <Menu.Item onClick={() => handleManageLicense(row.original.id)}>
                  <Text size="sm" style={{ fontFamily: 'Nunito Sans, sans-serif', color: '#595C60' }}>
                    Manage License
                  </Text>
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </div>
        );
      },
      mantineTableBodyCellProps: {
        style: {
          height: '48px',
          backgroundColor: 'transparent !important',
        },
      },
    },
  ];

  const table = useMantineReactTable({
    columns,
    data,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnResizing: true,
    enableColumnHiding: true,
    mantineTableContainerProps: {
      style: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '400px',
        paddingLeft: '20px',
        paddingRight: '20px',
      },
    },
    mantineTableProps: {
      style: {
        minWidth: 'max-content',
        tableLayout: 'fixed',
        fontFamily: 'Nunito Sans, sans-serif',
        backgroundColor: '#ffffff',
        width: '100%',
      },
      className: 'shadow-sm rounded-lg',
    },
    mantineTableHeadCellProps: {
      style: {
        whiteSpace: 'nowrap',
        backgroundColor: '#F1F4F9',
        borderBottom: '1px solid #e5e7eb',
        padding: '12px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '700',
        fontSize: '14px',
        color: '#202224',
      },
    },
    mantineTableBodyCellProps: {
      style: {
        whiteSpace: 'nowrap',
        padding: '12px',
        height: '48px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '600',
        color: '#595C60',
        backgroundColor: 'transparent !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
      },
    },
    mantineSelectCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': {
            border: '1px solid #202224 !important',
            backgroundColor: 'transparent !important',
          },
          '&:checked': {
            border: 'none !important',
            backgroundColor: '#FF7A00 !important',
          },
        },
        icon: {
          color: '#ffffff !important',
        },
        wrapper: {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent !important',
        },
      },
      className: 'custom-checkbox-cell',
    },
    mantineSelectAllCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': {
            border: '1px solid #202224 !important',
          },
          '&:checked': {
            border: 'none !important',
            backgroundColor: '#FF7A00 !important',
          },
        },
        icon: {
          color: '#ffffff !important',
        },
        wrapper: {
          borderBottom: '1px solid #e5e7eb',
        },
      },
    },
    mantineColumnVisibilityToggleButtonProps: {
      sx: {
        color: '#FF7A00 !important',
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: '#FFF3E5',
        },
        '& svg': {
          color: '#FF7A00 !important',
        },
      },
    },
    mantineTableToolbarProps: {
      sx: {
        '& .mantine-Menu-item': {
          color: '#FF7A00 !important',
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '14px',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#FFF3E5 !important',
          },
        },
        '& .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"], & .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"]': {
          color: '#FF7A00 !important',
          '&:hover': {
            backgroundColor: '#FFF3E5 !important',
          },
        },
      },
    },
    meta: {
      setCompanies,
      onEdit,
    },
  });

  useEffect(() => {
    // const res = getLicenseType();
    // console.log(res.data);

    if (setTableInstance) {
      setTableInstance(table);
    }
  }, [table, setTableInstance]);

  return (
    <div className="mb-5">
      <style>
        {`
          .custom-checkbox-cell,
          .custom-checkbox-cell * {
            background-color: transparent !important;
          }
          .custom-checkbox-cell:hover,
          .custom-checkbox-cell *:hover {
            background-color: transparent !important;
          }
          .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"],
          .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"] {
            color: #FF7A00 !important;
            font-family: 'Nunito Sans, sans-serif' !important;
            font-size: 14px !important;
          }
          .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"]:hover,
          .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"]:hover {
            background-color: #FFF3E5 !important;
          }
          .mantine-Menu-item {
            color: #595C60 !important;
            font-family: 'Nunito Sans, sans-serif' !important;
            font-size: 14px !important;
          }
          .mantine-Menu-item:hover {
            background-color: #FFF3E5 !important;
          }
        `}
      </style>

     <Table columns={columns} data={data}/>
     
      <ConfirmationModal
        open={isModalOpen}
        title="Delete Company"
        message="Are you sure you want to delete this company? This action cannot be undone."
        onConfirm={handleConfirmDelete}
        onCancel={() => {
          setIsModalOpen(false);
          setCompanyToDelete(null);
        }}
        confirmLabel="Confirm"
        cancelLabel="Cancel"
      />
    </div>
  );
};

export default CompanyTable;